<div class="tooltip-content">
  <div class="text">
    {{ content }}
  </div>
</div>
